module.exports = __webpack_public_path__ + "static/media/wolffox3.c6edd701.jpg";